export const Colors = {
  // main logo colors
  navy: "#22314E",
  primary: "#2F5496",
  primaryHover: "#5279C0",
  blue: "#29B4E6",
  orange: "#ED7D31",
  gray: "#ababab",
  yellow: "#FFC000",
  green: "#659C40",
  // black & white
  white: "#FFFFFF",
  black: "#000000",
  // feedback
  success: "#64E471",
  error: "#F74141",
  warning: "#FCE036",
  // background
  background: "#F8F8F8",
  // shadow
  shadow: "0px 1px 2px rgba(47, 84, 150, 0.5)",
  // gradient
  primaryGradient: "linear-gradient(63deg, rgba(47,84,150,1) 26%, rgba(41,180,230,1) 77%)",
  // text
  text: "#58687D"
};
